import { Card, CardContent, CardHeader, CardTitle } from "@devhop/ui";
import type { CfDashboardStatusCounts } from "../api/types";

// system enum -> label ลาว (อนุญาตให้ map ได้)
const STATUS_ROWS: Array<{ key: string; label: string; color: string }> = [
  { key: "pending", label: "ລໍຖ້າຢືນຢັນ", color: "bg-amber-500" },
  { key: "confirmed", label: "ຢືນຢັນແລ້ວ", color: "bg-blue-500" },
  { key: "paid", label: "ຈ່າຍແລ້ວ", color: "bg-violet-500" },
  { key: "shipped", label: "ຈັດສົ່ງ", color: "bg-cyan-500" },
  { key: "delivered", label: "ສົ່ງຮອດ", color: "bg-emerald-500" },
  { key: "cancelled", label: "ຍົກເລີກ", color: "bg-rose-500" },
];

type OrderStatusFunnelProps = {
  data?: CfDashboardStatusCounts;
  isLoading: boolean;
};

export function OrderStatusFunnel({ data, isLoading }: OrderStatusFunnelProps) {
  const total = data?.total ?? 0;

  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">ສະຖານະອໍເດີ (ຊ່ວງທີ່ເລືອກ)</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && !data ? (
          <div className="space-y-2 py-2">
            {STATUS_ROWS.map((r) => (
              <div
                key={r.key}
                className="h-6 w-full animate-pulse rounded bg-muted"
              />
            ))}
          </div>
        ) : total === 0 ? (
          <div className="py-8 text-center text-muted-foreground text-sm">
            ຍັງບໍ່ມີຂໍ້ມູນ
          </div>
        ) : (
          <div className="space-y-2.5">
            {STATUS_ROWS.map((r) => {
              const n = (data as Record<string, number>)?.[r.key] ?? 0;
              const pct = total > 0 ? Math.round((n / total) * 100) : 0;
              return (
                <div key={r.key} className="flex items-center gap-3">
                  <span className="w-24 shrink-0 text-sm">{r.label}</span>
                  <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-muted">
                    <div
                      className={`h-full rounded-full ${r.color}`}
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                  <span className="w-12 shrink-0 text-end font-medium text-sm tabular-nums">
                    {n}
                  </span>
                </div>
              );
            })}
            <div className="flex items-center justify-between border-t pt-2 text-sm">
              <span className="text-muted-foreground">ລວມທັງໝົດ</span>
              <span className="font-bold tabular-nums">{total}</span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
